<button
  type="button"
  class="resize-toggle-btn"
  aria-label="Abrir controle de largura do iframe"
  (click)="onToggleButtonsPanel()"
>
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
    <path
      d="M4 7h16M4 12h16M4 17h16M8 4l-4 3 4 3M16 4l4 3-4 3M8 14l-4 3 4 3M16 14l4 3-4 3"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</button>

<div class="resize-buttons-panel" *ngIf="isButtonsPanelOpen">
  <div class="buttons-control" role="radiogroup" aria-label="Largura do iframe">
    <div class="buttons-options">
      <button
        *ngFor="let option of sizeOptions; let i = index"
        type="button"
        class="size-option-button"
        [class.active]="selectedIndex === i"
        [attr.aria-checked]="selectedIndex === i"
        role="radio"
        (click)="onSelectIndex(i)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</div>
